import axios from 'axios';

/** no types */
// @ts-ignore
import getCountryISO3 from 'country-iso-2-to-3';
import {
  IAddressForm,
  ICustomerForm,
  IOrder,
  User,
} from 'commerce/scayle/auth/types';
import {
  CheckoutApiUrls,
  IAddress,
  IUpdateAddress,
} from 'commerce/scayle/checkout/types';
import { errorWrapper } from 'commerce/utils/network';
import { getScayleSiteConfig } from '../common';

export const getCustomerInformation = async () => {
  const customer = await errorWrapper(getCustomerInformation.name, () =>
    axios.get<User>(CheckoutApiUrls.GET_CUSTOMER),
  );
  return customer.response?.data || null;
};

export const getCustomerOrder = async (orderId: string | number) => {
  const customer = await errorWrapper(getCustomerOrder.name, () =>
    axios.get<IOrder>(`${CheckoutApiUrls.GET_CUSTOMER_ORDER}/${orderId}`),
  );
  return customer.response?.data;
};

export const getCustomerAddresses = async () => {
  const addresses = await errorWrapper(getCustomerAddresses.name, () =>
    axios.get<{ entities: IAddress[] }>(CheckoutApiUrls.GET_ADDRESSES),
  );
  return addresses.response?.data?.entities || null;
};

export const createCustomerAddress = (userId: number, data: IAddressForm) => {
  return errorWrapper(createCustomerAddress.name, async () => {
    const config = await getScayleSiteConfig();

    return axios.post(CheckoutApiUrls.CREATE_ADDRESS, {
      city: data.city,
      additional: data.street2 || ' ',
      recipient: {
        firstName: data.firstName,
        lastName: data.lastName,
        gender: data.gender,
      },
      isDefault: data.isDefault || {
        billing: true,
        shipping: true,
      },
      // houseNumber is required
      houseNumber: data.street.trim().split(' ').slice(-1)?.[0] || '',
      street: data.street.trim().split(' ').slice(0, -1).join(' '),
      zipCode: data.zip,
      countryCode: getCountryISO3(config.country),
      customer: { id: userId },
      /** collectionPoint need for sending packstation data */
      ...(data.collectionPoint?.type && {
        collectionPoint: data.collectionPoint,
      }),
    });
  });
};

export const updatePassword = (password: string, newPassword: string) => {
  return errorWrapper(updatePassword.name, () =>
    axios.put(CheckoutApiUrls.UPDATE_PASSWORD, {
      password,
      newPassword,
    }),
  );
};

export const updatePersonalData = (
  data: Pick<ICustomerForm, 'firstName' | 'lastName' | 'gender'>,
) => {
  return errorWrapper(updatePersonalData.name, () =>
    axios.put(CheckoutApiUrls.UPDATE_PERSONAL_DATA, data),
  );
};

export const updateAddressById = (id: number, data: IUpdateAddress) => {
  return errorWrapper(updateAddressById.name, () =>
    axios.patch(`${CheckoutApiUrls.CREATE_ADDRESS}/${id}`, data),
  );
};

export const updateEmail = (email: string) => {
  return errorWrapper(updateEmail.name, () =>
    axios.put(CheckoutApiUrls.UPDATE_EMAIL, { newEmail: email }),
  );
};

export const updateCompany = (company?: string, tax?: string) => {
  return errorWrapper<{}>(updateCompany.name, () =>
    axios.put(CheckoutApiUrls.UPDATE_CUSTOM_DATA, {
      company: {
        name: company,
        'tax-number': tax,
      },
    }),
  );
};

export const updateSender = (senderId: string) => {
  return errorWrapper(updateSender.name, () =>
    axios.put(CheckoutApiUrls.UPDATE_CUSTOM_DATA, {
      senderId,
    }),
  );
};
